import type { LucideIcon, LucideProps } from 'lucide-react';
import { cx } from './cx';

export interface IconProps extends Omit<LucideProps, 'ref'> {
  icon: LucideIcon;
  /** Directional icons (arrows, chevrons) flip in RTL (§23.1). */
  directional?: boolean;
}

/** Lucide at the §23.1 defaults: 20 px, 1.5 px stroke, hidden from screen readers. */
export function Icon({ icon: Glyph, directional, className, size = 20, ...rest }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={1.5}
      nonScalingStroke
      aria-hidden
      focusable={false}
      className={cx('kd-icon', directional && 'kd-icon--directional', className)}
      {...rest}
    />
  );
}
